import React, { useEffect, useState } from 'react'
import { Row, Col, Button } from 'antd'
import { getRoomHistory, timestampTodate, genVRoomToken, isFetchReserve, dateDiffDuration, IconHelper, formatNumberTwo } from '../../helpers'
import Tabs from './Tabs'
import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'
import { translate } from 'react-i18next'

import analytics from '../../libs/analytics'

const RoomList = ({ keycloak, authenticated, language, t }) => {
    const [roomHistory, SetRoomHistory] = useState([])
    const conferencesList = useSelector(state => state.conference.conferencesList)
    const { IconTable, IconClock, IconRecurring } = IconHelper

    useEffect(() => {
        const history = getRoomHistory()
        SetRoomHistory(history)
    }, [])

    // const linkToDetail = (id) => () => {
    //     window.open(`${window._env_.mymeeting}/finished/${id}?fullCalendar=true#conference`)
    // }

    const roomList = authenticated && isFetchReserve()
        ? conferencesList.slice(0, 3).map((room, index) => {
            const roomCondition = isEmpty(room.recurring_name) ? room.name : room.recurring_name
            let pathnameTmp = roomCondition.replace(/%20/g, ' ')
            let startDate = timestampTodate(room.starttime, language).split(",")
            let endDate = timestampTodate(room.stoptime, language).split(",")
            let getDulation = dateDiffDuration(room.starttime, room.stoptime)
            let dulation = `${formatNumberTwo(getDulation.hours)}:${formatNumberTwo(getDulation.minutes)}:${formatNumberTwo(getDulation.seconds)}`
            let roomName
            let roomUrl
            if (/(?!%22)[!@#$%^&*]/.test(pathnameTmp)) {
                roomName = roomCondition
                roomUrl = room.name
            } else {
                roomName = decodeURIComponent(roomCondition)
                roomUrl = decodeURIComponent(room.name)
            }
            const showDate = `${startDate[0] || ''},${startDate[1].toLocaleUpperCase() || ''} - ${startDate[0] === endDate[0] ? '' : endDate[0] + ','}${endDate[1].toLocaleUpperCase() || ''}`
            return (
                <div style={{ display: 'contents' }} key={Math.random().toString(36).substring(7)}>
                    <Row className="room-list">
                        <Col span={24} className="txt-info">
                            <p className="first-line-history">
                                {!isEmpty(room.recurring_name) && <IconRecurring style={{ marginRight: '5px' }} />}{roomName}
                            </p>
                            <p className="second-line-history"><IconTable style={{ marginRight: '5px' }} />{showDate}</p>
                            <p className="second-line-history"><IconClock style={{ marginRight: '5px' }} />{room.stoptime === undefined ? '-' : dulation}</p>
                        </Col>
                        <div style={{ borderTop: '1px solid #EFEFEF', margin: '16px 40px', width: '100%' }}></div>
                        <Col span={24} className="button-room">
                            <Button onClick={() => goTomeet(roomUrl)}>
                                {t('btn_start_recent')}
                            </Button>
                            {/* <Button onClick={linkToDetail(room.id)}>
                                {t('btn_detail_recent')}
                            </Button> */}
                        </Col>
                    </Row>
                </div >
            )
        })
        : roomHistory.slice(0, 3).map((room, index) => {
            let l = document.createElement("a");
            l.href = room.conference;
            let roomName = l.pathname.substring(1)
            let date = timestampTodate(room.date, language).split(",")
            const roomDuration = parseInt(room.date) + parseInt(room.duration)
            let preEndDate = new Date(roomDuration)
            const endDate = timestampTodate(preEndDate, language).split(",")
            const showDate = `${date[0] || ''},${date[1].toLocaleUpperCase() || ''} - ${date[0] === endDate[0] ? '' : endDate[0] + ','}${endDate[1].toLocaleUpperCase() || ''}`
            let getDulation = dateDiffDuration(room.date, roomDuration)
            let dulation = room.duration === 0 ? '-' : `${formatNumberTwo(getDulation.hours)}:${formatNumberTwo(getDulation.minutes)}:${formatNumberTwo(getDulation.seconds)}`
            return (
                <Row className="room-list" key={Math.random().toString(36).substring(7)}>
                    <Col span={24} className="txt-info">
                        <p className="first-line-history">{decodeURIComponent(roomName)}</p>
                        <p className="second-line-history"><IconTable style={{ marginRight: '5px' }} />{showDate}</p>
                        <p className="second-line-history"><IconClock style={{ marginRight: '5px' }} />{dulation}</p>
                    </Col>
                    <div style={{ borderTop: '1px solid #EFEFEF', margin: '16px 40px', width: '100%' }}></div>
                    <Col span={24} className="button-room">
                        <Button onClick={() => goTomeet(roomName)}>
                            {t('btn_start_recent')}
                        </Button>
                    </Col>
                </Row>
            )
        });

    const goTomeet = async (pathname) => {
        analytics.sendEvent({
            category: 'Home',
            action: 'Homepage-StartAgain-Button-Clicked',
        });

        if (authenticated) {
            const vRoomToken = await genVRoomToken(keycloak)
            window.location.href = `${window._env_.vRoomUrl}/${pathname}?jwt=${vRoomToken}`
        } else {
            window.location.href = `${window._env_.vRoomUrl}/${pathname}`
        }
    }

    return (
        <>
            <Row type="flex" justify="center" >
                {
                    !isEmpty(keycloak) ? (
                        <Tabs roomList={roomList} keycloak={keycloak} authenticated={authenticated} language={language} conferenceCount={conferencesList.length} />
                    ) : null
                }
            </Row >
        </>
    )
}

export default translate()(RoomList)
